export const name = 'presetDeleteController';
export default function presetDeleteController($mdDialog, $log, presetsService, errorDialogOpen, analyticsFactory, $translate) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  vm.cancel = cancel;
  vm.delete = deletePreset;
  vm.isInProgress = false;
  vm.numOfElementsToDelete = vm.listOfElementToDelete.length;

  $translate.onReady(function() {
    vm.confirmDeletionTranslation = $translate.instant('imposer.composer-main.sdk_management_delete_confirm').replace('{0}', vm.numOfElementsToDelete);
  });

  function cancel(data) {
    let functionName='presetDeleteController.cancel';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));
    $mdDialog.cancel();
    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  function deletePreset(){
    vm.isInProgress = true;
    vm.deleteFunc(vm.listOfElementToDelete).then(()=> {
      $mdDialog.hide();
    }, error => {
      $mdDialog.hide();
    });
  }
}
